export default function ScrollToTop(target = null) {
  const scrollEl = target || window.document.querySelector('[data-main]');
  if (!scrollEl) return;
  scrollEl.scrollIntoView(true);
}
